// extracted by mini-css-extract-plugin
module.exports = {"container":"_1ogQx","wrapper":"LRAQQ","items-wrapper":"_34Wun","ad-slot":"_2ih0x"};